import classNames from 'classnames';
import React from 'react';

import css from './OutlineLabel.module.scss';

interface Props {
  className?: string;
  label: string;
}

export const OutlineLabel = ({ className, label }: Props) => {
  const classes = classNames(css.OutlineLabel, className);

  return <span className={classes}>{label}</span>;
};
